import { render, staticRenderFns } from "./ModalContextoSessao.vue?vue&type=template&id=6fdb5a13"
import script from "./ModalContextoSessao.vue?vue&type=script&lang=js"
export * from "./ModalContextoSessao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports